export default defineAppConfig({
  ui: {
    primary: 'craft',
    gray: 'cool',
    tooltip: {
      default: {
        openDelay: 500
      }
    },
    notifications: {
      // Show toasts at the top right of the screen
      // position: 'top-10 bottom-auto left-1/2 -translate-x-1/2',
      position: 'top-12 bottom-auto right-0',
    },
    input: {
      base: 'relative block w-full disabled:cursor-not-allowed disabled:opacity-75 disabled:bg-gray-100 focus:outline-none border-0',
    },
    variables: {
      light: {
        background: '255 255 255',
        foreground: 'var(--color-gray-700)'
      },
      dark: {
        background: 'var(--color-gray-900)',
        foreground: 'var(--color-gray-200)'
      },
      header: {
        height: '4rem'
      }
    },
    icons: {
      dark: 'i-heroicons-moon-20-solid',
      light: 'i-heroicons-sun-20-solid',
      system: 'i-heroicons-computer-desktop-20-solid',
      search: 'i-heroicons-magnifying-glass-20-solid',
      external: 'i-heroicons-arrow-up-right-20-solid',
      chevron: 'i-heroicons-chevron-down-20-solid',
      hash: 'i-heroicons-hashtag-20-solid',
      menu: 'i-heroicons-bars-3-20-solid',
      close: 'i-heroicons-x-mark-20-solid',
      check: 'i-heroicons-check-circle-20-solid'
    },
  }
})
